import { H3 } from '@h3/types';
import { request } from '@h3/request';

/** 获取不同场景支持的函数列表 */
export const getFormulaFunctionList = (params: H3.Formula.Request.TFormulaFunctionListModel) =>
    request<H3.Http.Response.H3Response<H3.Formula.Response.TFormulaFunctionListModel>>('/v1/formula/function/list', {
        method: H3.Http.MethodType.GET,
        params,
    });
